import { StoryblokActions } from './action';

/** TODO: Add type */
export type StoryblokState = any;

export const defaultStoryblokState: StoryblokState = {
    AdvantageItems: null,
    ArticleItems: null,
    ErrorItems: null,
    FactorgroupItems: null,
    FooterItem: null,
    HeaderItem: null,
    MiddlestepItems: null,
    OfferItems: null,
    PageItems: null,
    StringsItems: null,
};

export const storyblokReducer = (
    state: StoryblokState = defaultStoryblokState,
    action: StoryblokActions,
): StoryblokState => {
    switch (action.type) {
        case 'ADD_STORYBLOK_DATA':
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};
